import type { VoidFunctionComponent } from 'react';

import Button from '../../../generic/Button/Button';
import FormGroup from '../../../generic/Forms/FormGroup';
import LabeledTextInput from '../../../generic/Forms/LabeledTextInput';

type CocoapodsSource = {
  //  ID exists for sources which have been saved to the DB, but doesn't exist for new sources.
  id?: number;
  url: string;
  onRemoveSource: () => void;
  onUpdateSource: (url: string) => void;
};

/**
 * Source represents a user configurable cocoapods spec repo URL that is used to download private cocoapods dependencies
 */
const Source: VoidFunctionComponent<CocoapodsSource> = ({
  id,
  url,
  onRemoveSource,
  onUpdateSource,
}) => (
  <div className="margin-bottom-sm">
    <FormGroup direction="row" spacing="sm" baselineAlignment>
      <LabeledTextInput
        labelVariant="legacy"
        label="URL"
        size="small"
        value={url}
        // Existing URLs may not be edited. They must be deleted first
        isDisabled={!!id}
        onChange={onUpdateSource}
        placeholder="https://github.com/org/repo"
      />
      <Button
        type="error"
        size="small"
        onClick={onRemoveSource}
      >
        Remove
      </Button>
    </FormGroup>
  </div>
);

export default Source;
